export default __webpack_public_path__ + "static/media/Asset186.d32abd8b.svg";